import React from 'react';
import './index.scss';
import { spreadLevel, HEADER_TEXT } from './constants';
import SectionHeader from '../../../../../SectionHeader';

const StakeholderGroupsAlignment = (props) => {
    let stakeholdersAlignmentData = props.fetchRankDeltaApi.data && props.fetchRankDeltaApi.data.data ? props.fetchRankDeltaApi.data.data : []
    let stakeholdersAlignmentGroups = props.fetchRankDeltaApi.data && props.fetchRankDeltaApi.data.groups ? props.fetchRankDeltaApi.data.groups : []
    return (
        <>
            <SectionHeader
                title={HEADER_TEXT.title}
                description={HEADER_TEXT.description}
            />
        <div className='cardwrapper'>
            <div className='sga'>
                <div className='sga__subtitle'>
                    Every stakeholder group's rank order of the same six categories, side by side.
                    The Spread column shows the gap between the highest and lowest rank — a quick read
                    on which categories are contested versus agreed upon.
                </div>

                <div className='sga__table-wrap'>
                    <table className='sga__table'>
                        <thead>
                            <tr>
                                <th className='sga__th sga__th--category'>Category</th>
                                    {stakeholdersAlignmentGroups.map((group) => (
                                    <th key={group.key} className='sga__th sga__th--rank'>
                                        {group.label}
                                    </th>
                                ))}
                                <th className='sga__th sga__th--spread'>Spread</th>
                            </tr>
                        </thead>
                        <tbody>
                                {stakeholdersAlignmentData.map((row) => {
                                    const spread = row.spread;
                                const level = spreadLevel(spread);
                                return (
                                    <tr key={row.category}>
                                        <td className='sga__td sga__td--category'>{row.category}</td>
                                        {stakeholdersAlignmentGroups.map((group) => (
                                            <td key={group.key} className='sga__td sga__td--rank'>
                                                <span className='sga__rank'>{row[group.key]}</span>
                                            </td>
                                        ))}
                                        <td className='sga__td sga__td--spread'>
                                            <span className={`sga__spread sga__spread--${level}`}>
                                                {spread}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <div className='sga__note'>
                    Spread 0 = every group ranked it the same; higher = greater disagreement.
                </div>
            </div>
        </div>
        </>
    );
};

export default StakeholderGroupsAlignment;
